import React from "react";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import userSession, { forceLogout } from "../../Constant/auth";
import '../../Pages/HomePage.css'
const LogoutModal = () => {
  const { CustID, authHeader } = userSession;
  const logoutUser = (custID) => {
    const url = `/sn-auth-service/${custID}/logout`;

    const options = {
      method: "POST",
      headers: {
        Authorization: `${authHeader}`, // Include the bearer token in the Authorization header
      },
    };

    return fetch(url, options)
      .then((response) => {
        if (!response.ok) {
          console.error("Logout failed:", response.statusText);
        }
      })
      .catch((error) => {
        console.error("Error during logout:", error);
      });
  };

  const handleLogout = async () => {
    // Invalidate the token server-side BEFORE clearing local state and
    // navigating - the previous order reloaded the page first, which cancelled
    // the request and left the token alive in the DB until it expired.
    await logoutUser(CustID);
    forceLogout("user logged out");
  };

  return (
    <div
      className="modal fade showNormalFont"
      id="logoutModal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body d-flex flex-column justify-content-between align-items-center">
            <span className="text-center">
              <AiOutlineExclamationCircle className="info-logout-Icon" />
            </span>
            <h2 className="logout-icon-info-title" id="logout-icon-info-title">
              Are you sure?
            </h2>
            <span className="logout-icon-info-text">
              You will be logged out of the app
            </span>
            <div className="d-flex mt-3 mb-2">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleLogout}
              >
                Logout
              </button>
              <button
                type="button"
                className="btn btn-danger ms-4"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
